import { API } from "@/services/api";
import { authEndpoints } from "@/constant/endpoints";
import { IAPIResponse } from "@/services/api.types";
import {
  AuthResponse,
  AuthUser,
  CheckResetTokenResponse,
  ForgotPasswordFormData,
  ForgotPasswordResponse,
  LoginFormData,
  MeContextResponse,
  PhoneLoginVerifyData,
  RegisterFormData,
  ResetPasswordFormData,
} from "@/types/authentication.types";

export const registerService = async (payload: RegisterFormData): Promise<IAPIResponse<AuthResponse>> => {
  return API.Post<RegisterFormData, AuthResponse>(authEndpoints.register, payload);
};

export const sendSignupOtpService = async (email: string): Promise<IAPIResponse<{ ok: boolean }>> => {
  return API.Post<{ email: string }, { ok: boolean }>(authEndpoints.registerOtp, { email });
};

export const loginService = async (payload: LoginFormData): Promise<IAPIResponse<AuthResponse>> => {
  return API.Post<LoginFormData, AuthResponse>(authEndpoints.login, payload);
};

export const phoneLoginStartService = async (phone: string): Promise<IAPIResponse<{ expires_in_minutes: number }>> => {
  return API.Post<{ phone: string }, { expires_in_minutes: number }>(authEndpoints.phoneLoginStart, { phone });
};

export const phoneLoginVerifyService = async (payload: PhoneLoginVerifyData): Promise<IAPIResponse<AuthResponse>> => {
  return API.Post<PhoneLoginVerifyData, AuthResponse>(authEndpoints.phoneLoginVerify, payload);
};

export const forgotPasswordService = async (payload: ForgotPasswordFormData): Promise<IAPIResponse<ForgotPasswordResponse>> => {
  return API.Post<ForgotPasswordFormData, ForgotPasswordResponse>(authEndpoints.forgot, payload);
};

export const resetPasswordService = async (payload: ResetPasswordFormData): Promise<IAPIResponse<AuthResponse>> => {
  return API.Post<ResetPasswordFormData, AuthResponse>(authEndpoints.reset, payload);
};

export const getMeService = async (): Promise<AuthUser> => {
  const response = await API.Get<AuthUser>(authEndpoints.me);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const getMeContextService = async (): Promise<MeContextResponse> => {
  const response = await API.Get<MeContextResponse>(authEndpoints.meContext);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const checkResetTokenService = async (token: string): Promise<CheckResetTokenResponse> => {
  const response = await API.Get<CheckResetTokenResponse>(authEndpoints.checkResetToken(token));
  if (response.data) return response.data;
  throw new Error(response.message);
};
